import { LuLayers, LuPackage } from "react-icons/lu";
import { Edition } from "./edition";
import { getCatalogs } from "../../../../api/catalogs";
import { TableLayout } from "../../layouts/table";
import { CollectionSummary } from "../../../../components/collectionTools";
import { CatalogList } from "./catalogList";
import "./style.css";
export const Catalogs = () => (
  <section className="catalogsReference">
    <TableLayout
      title="Catálogos"
      addText="Nuevo catálogo"
      edition={<Edition identificator="catalogs" />}
      get={getCatalogs}
      idKey="catalogId"
      identificator="catalogs"
      renderSummary={(rows) => (
        <CollectionSummary
          items={[
            { label: "Catálogos", icon: <LuLayers />, value: rows.length },
            {
              label: "Productos asignados",
              icon: <LuPackage />,
              value: rows.reduce(
                (total, row) => total + (row.Products?.length || 0),
                0,
              ),
            },
          ]}
        />
      )}
      renderContent={(rows, onEdit) => (
        <CatalogList rows={rows} onEdit={onEdit} />
      )}
    />
  </section>
);
